import script from "./CampaignFormatSlotIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CampaignFormatSlotIcon.vue?vue&type=script&setup=true&lang=ts"

import "./CampaignFormatSlotIcon.vue?vue&type=style&index=0&id=40a18974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a18974"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
